var map = {
	"./dice-1.png": 28842,
	"./dice-2.png": 59425,
	"./dice-3.png": 38296,
	"./dice-4.png": 87287,
	"./dice-5.png": 41710,
	"./dice-6.png": 12069
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43878;